import React, {Component} from 'react'
import Route, {default as Links} from "../../Route";
import HttpRequest from "../../HttpRequest";
import Components from "../../components";
import loading from "../../images/loading.gif"


class PaySession extends Component {

    constructor(props){
        super(props);
        this.httpClient = new HttpRequest();
        this.token = props.token ? props.token : "";
        this.purchaseToken = props.purchaseToken ? props.purchaseToken : "";
        this.isPaymentSuccessfulLink = false;
        if(this.purchaseToken && this.props.link === Route.PaySessionSuccessful.link){
            this.isPaymentSuccessfulLink = true;
        }
        this.server = {};
        this.state = {
            server: {},
            isLoadCompleted: false,
            showForm: false,
        };
    }

    render(){
        let messageElement = "";
        if(!this.state.isLoadCompleted){
            messageElement = (<Components.PageLoader data={{
                loaderMessage: "Patientez, vérification en cours...",
                image: {
                    src: loading,
                    alt: 'loading',
                    width: 90,
                }
            }} />);
        }
        if(this.state.showAlert){
            let content = "Une erreur s'est produite !", alertClass = Components.Dialogs.ALERT_TYPES.DANGER;
            if(this.state.hasAsyncError){
                content = "Nos serveurs sont en maintenance. Revenez ultérieurement!";
            }
            else{
                if(this.server && [200, 201].includes(this.server.code)){
                    alertClass = Components.Dialogs.ALERT_TYPES.SUCCESS;
                }
                if(this.server.message){
                    content = this.server.message;
                }
            }
            messageElement = <Components.Dialogs.AlertDialog  data={{content: content, iconClass: "", alertClass: alertClass}} />;
        }
        return (
            <>
                <div className="inner-head bg-animate">
                    <div className="container mt-6">
                        <div className="row text-center">
                            <div className="col-md-8 col-md-offset-2 mt-6">
                                <h3 className="">Vérification du paiement</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="inner-page " style={{overflow: "none", minHeight: "400px", fontSize: "2em"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-8 mt-6">
                                {messageElement}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    componentDidMount() {
        const _self = this;
        let route = this.isPaymentSuccessfulLink ? Links.APIPaymentsCheckPaySessionSuccessful.replace("{purchaseToken}", this.purchaseToken) : Links.APIPaymentsCheckPaySession.replace("{token}", this.token);

        this.httpClient.request(route, "GET").then(function (response){
            _self.server = response;
            const state = {server: response, isLoadCompleted: true, showAlert: true};

            if(response.code === 200 && !_self.isPaymentSuccessfulLink && response.data.redirect_url){
                window.location = response.data.redirect_url;
                return;
            }

            _self.setState({...state});
        }).catch(function (error){
            _self.setState({showAlert: true, hasAsyncError: true});
        });
    }
}

export default PaySession;